import ReduxHelper from 'lib/ReduxHelper';
import { MERCHANT_FEES_ACTION_TYPES as AT } from './Fees.actions';
import moment from 'moment';
import 'moment/locale/el';

export const defaultState = {
  merchantsFeesDataError: null,
  fetchingMerchantsFeesData: false,
  merchantsFeesData: null,

  updateMerchantsFeesDataError: null,
  updatingMerchantsFeesData: false,
  updateMerchantsFeesData: null,
};

const feesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case AT.MERCHANT_FEES_FETCH_DATA: {
      return Object.assign({}, state, { fetchingMerchantsFeesData: true });
    }
    case AT.MERCHANT_FEES_FETCH_DATA_SUCCESS: {
      const fees = action.payload?.AuctionsFees;

      return Object.assign({}, state, {
        fetchingMerchantsFeesData: false,
        merchantsFeesData: fees.map(x => {
          return {
            ...x,
            PaymentDate: moment.utc(x.PaymentDate),
            EndDate: moment.utc(x.EndDate),
          };
        }),
        merchantsFeesDataError: null,
      });
    }
    case AT.MERCHANT_FEES_FETCH_DATA_FAIL:
      return Object.assign({}, state, {
        fetchingMerchantsFeesData: false,
        merchantsFeesData: null,
        merchantsFeesDataError: ReduxHelper.extractError(action),
      });
    case AT.MERCHANT_FEES_FETCH_CLEAR_DATA:
      return Object.assign({}, state, {
        fetchingMerchantsFeesData: false,
        merchantsFeesData: null,
        merchantsFeesDataError: null,
      });
    case AT.MERCHANT_FEES_UPDATE_DATA: {
      return Object.assign({}, state, { updatingMerchantsFeesData: true });
    }
    case AT.MERCHANT_FEES_UPDATE_DATA_SUCCESS: {
      return Object.assign({}, state, {
        updatingMerchantsFeesData: false,
        updateMerchantsFeesData: action.payload,
        updateMerchantsFeesDataError: null,
      });
    }
    case AT.MERCHANT_FEES_UPDATE_DATA_FAIL:
      return Object.assign({}, state, {
        updatingMerchantsFeesData: false,
        updateMerchantsFeesData: null,
        updateMerchantsFeesDataError: ReduxHelper.extractError(action),
      });
    case AT.MERCHANT_FEES_UPDATE_CLEAR_DATA:
      return Object.assign({}, state, {
        updatingMerchantsFeesData: false,
        updateMerchantsFeesData: null,
        updateMerchantsFeesDataError: null,
      });
    default:
      return state;
  }
};

export default feesReducer;
